<template>
  <div v-if="['tap', 'zoom', 'swipe', 'path'].includes(eventType)" class="path-option">
    <div v-if="eventType === 'path'" class="path__wrap">
      <div class="box__wrap">
        <div class="box" :class="{ on: typeSource === 1 }" @click="typeSourceChange(1)">
          <span class="info">{{ $t(`heatmap.type.path.average.title`) }}</span>
          <i class="icon icon--path-info" :class="typeSource === 1 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(1)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 1">
              <i class="arrow"></i>
              <div class="title">{{ 'Activity-Statistics' }}</div>
              <div class="reporting__stream__statistics-graph">
                <div class="lines">
                  <div class="vertical">
                    <span></span><span></span><span></span>
                  </div>
                  <div class="horizontal">
                    <span></span><span></span><span></span>
                  </div>
                </div>
                <div class="line nothing"></div>
                <div class="line median active">
                  <span class="label"></span>
                  <span class="name" v-html="$t(`heatmap.type.path.average.title`)"></span>
                </div>
                <div class="line extreme">
                  <span class="label"></span>
                  <span class="name extreme" v-html="$t(`heatmap.type.path.engage.title`)"></span>
                </div>
              </div>
              <div class="description" v-html="$t(`heatmap.journey.path.average.description`)"></div>
              <div class="alert__wrap">
                <i class="icon icon--path-info black"></i>
                <div class="alert" v-html="$t(`heatmap.journey.path.average.alert`)"></div>
              </div>
            </div>
          </i>
        </div>
        <div class="box" :class="{ on: typeSource === 0 }" @click="typeSourceChange(0)">
          <span class="info">{{ $t(`heatmap.type.path.engage.title`) }}</span>
          <i class="icon icon--path-info" :class="typeSource === 0 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(0)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 0">
              <i class="arrow"></i>
              <div class="title">{{ 'Activity-Statistics' }}</div>
              <div class="reporting__stream__statistics-graph">
                <div class="lines">
                  <div class="vertical">
                    <span></span><span></span><span></span>
                  </div>
                  <div class="horizontal">
                    <span></span><span></span><span></span>
                  </div>
                </div>
                <div class="line nothing"></div>
                <div class="line median">
                  <span class="label"></span>
                  <span class="name" v-html="$t(`heatmap.type.path.average.title`)"></span>
                </div>
                <div class="line extreme active">
                  <span class="label"></span>
                  <span class="name extreme" v-html="$t(`heatmap.type.path.engage.title`)"></span>
                </div>
              </div>
              <div class="description orange" v-html="$t(`heatmap.journey.path.engage.description`)"></div>
              <div class="alert__wrap">
                <i class="icon icon--path-info black"></i>
                <div class="alert" v-html="$t(`heatmap.journey.path.engage.alert`)"></div>
              </div>
            </div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="eventType === 'zoom'" class="zoom__wrap">
      <div class="box__wrap">
        <div class="box" :class="{ on: typeSource === 0 }" @click="typeSourceChange(0)">
          <i class="icon icon--heatmap-zoom-in"></i>
          <span class="info">{{ $t(`heatmap.type.zoom.in.title`) }}</span>
          <i class="icon icon--path-info" :class="typeSource === 0 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(0)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 0">
              <i class="arrow"></i>
              <div class="title"><span>{{ $t(`heatmap.journey.zoom.in.title`) }}</span><span class="percentage">(%)</span>
              </div>
              <div class="legend weight">
                <div class="item">
                  <i class="icon zoomin weight-5"></i>
                  <h3 class="line"></h3>
                  <span>Max.</span>
                </div>
                <div class="item">
                  <i class="icon zoomin weight-4"></i>
                </div>
                <div class="item">
                  <i class="icon zoomin weight-3"></i>
                </div>
                <div class="item">
                  <i class="icon zoomin weight-2"></i>
                </div>
                <div class="item">
                  <i class="icon zoomin weight-1"></i>
                  <span>Min.</span>
                </div>
              </div>
            </div>
          </i>
        </div>
        <div class="box" :class="{ on: typeSource === 1 }" @click="typeSourceChange(1)">
          <i class="icon icon--heatmap-zoom-out"></i>
          <span class="info">{{ $t(`heatmap.type.zoom.out.title`) }}</span>
          <i class="icon icon--path-info" :class="typeSource === 1 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(1)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 1">
              <i class="arrow"></i>
              <div class="title"><span>{{ $t(`heatmap.journey.zoom.out.title`) }}</span><span class="percentage">(%)</span>
              </div>
              <div class="legend weight">
                <div class="item">
                  <i class="icon zoomout weight-5"></i>
                  <h3 class="line"></h3>
                  <span>Max.</span>
                </div>
                <div class="item">
                  <i class="icon zoomout weight-4"></i>
                </div>
                <div class="item">
                  <i class="icon zoomout weight-3"></i>
                </div>
                <div class="item">
                  <i class="icon zoomout weight-2"></i>
                </div>
                <div class="item">
                  <i class="icon zoomout weight-1"></i>
                  <span>Min.</span>
                </div>
              </div>
            </div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="eventType === 'swipe'" class="swipe__wrap">
      <div class="box__wrap">
        <div class="box" :class="{ on: typeSource === 0 ? true : false }" @click="typeSourceChange(0)">
          <i class="icon icon--heatmap-swipe-vertical marginright"></i>
          <span class="info">{{ $t('heatmap.type.swipe.vert.title') }}</span>
          <i class="icon icon--path-info" :class="typeSource === 0 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(0)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 0">
              <i class="arrow"></i>
              <div class="title">
                <span class="orange">{{ $t(`heatmap.journey.swipe.vertical.title`) }}</span>
                <span class="percentage">(%)</span>
              </div>
              <div class="legend">
                <div class="item">
                  <i class="icon up weight-5"></i>
                  <span>100 ~ 80</span>
                  <i class="icon down weight-5"></i>
                </div>
                <div class="item">
                  <i class="icon up weight-4"></i>
                  <span>79 ~ 60</span>
                  <i class="icon down weight-4"></i>
                </div>
                <div class="item">
                  <i class="icon up weight-3"></i>
                  <span>59 ~ 40</span>
                  <i class="icon down weight-3"></i>
                </div>
                <div class="item">
                  <i class="icon up weight-2"></i>
                  <span>39 ~ 20</span>
                  <i class="icon down weight-2"></i>
                </div>
                <div class="item">
                  <i class="icon up weight-1"></i>
                  <span>19 ~ 1</span>
                  <i class="icon down weight-1"></i>
                </div>
              </div>
            </div>
          </i>
        </div>
        <div class="box" :class="{ on: typeSource === 1 }" @click="typeSourceChange(1)">
          <i class="icon icon--heatmap-swipe-horizontal marginright"></i>
          <span class="info">{{ $t('heatmap.type.swipe.horz.title') }}</span>
          <i class="icon icon--path-info" :class="typeSource === 1 ? 'white' : 'black'"
            @mouseenter="showTooltipDetail(1)" @mouseleave="hideTooltipDetail()">
            <div class="path-tooltip" v-if="tooltipDetail === 1">
              <i class="arrow"></i>
              <div class="title">
                <span class="orange">{{ $t(`heatmap.journey.swipe.horizontal.title`) }}</span>
                <span class="percentage">(%)</span>
              </div>
              <div class="legend vertical">
                <div class="item">
                  <i class="icon left weight-5"></i>
                  <span>100 ~ 80</span>
                  <i class="icon right weight-5"></i>
                </div>
                <div class="item">
                  <i class="icon left weight-4"></i>
                  <span>79 ~ 60</span>
                  <i class="icon right weight-4"></i>
                </div>
                <div class="item">
                  <i class="icon left weight-3"></i>
                  <span>59 ~ 40</span>
                  <i class="icon right weight-3"></i>
                </div>
                <div class="item">
                  <i class="icon left weight-2"></i>
                  <span>39 ~ 20</span>
                  <i class="icon right weight-2"></i>
                </div>
                <div class="item">
                  <i class="icon left weight-1"></i>
                  <span>19 ~ 1</span>
                  <i class="icon right weight-1"></i>
                </div>
              </div>
            </div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="eventType === 'tap'" class="tap__wrap">
      <div class="box">
        <i class="icon icon--heatmap-tap"></i>
        <span>{{ 'Tap' }}</span>
      </div>
      <div class="box">
        <i class="icon icon--heatmap-double-tap"></i>
        <span>{{ 'Double Tap' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tooltipDetail: false
    }
  },
  props: [
    'typeSource',
    'eventType'
  ],
  methods: {
    typeSourceChange (value) {
      const typeSource = value
      this.$emit('onChangeTypeSource', typeSource)
    },
    showTooltipDetail (value) {
      this.tooltipDetail = value
    },
    hideTooltipDetail () {
      this.tooltipDetail = false
    }
  }
}
</script>
<style lang="scss" scoped>
.path-option {
  width: auto;
  text-align: center;
  position: absolute;
  z-index: 5;
  left: 0;
  right: 0;
  margin: 0 20px;
  //margin-left: 20px;
  background: #1B1B1D;

  .arrow {
    content: '';
    background-color: #1B1B1D;
    position: absolute;
    z-index: 2;
    top: -6px;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }
  .path__wrap {
    display: flex;
    justify-content: center;
    padding: 8px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    .box__wrap {
      display: flex;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.10);
      background: rgba(0, 0, 0, 0.40);
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 26px;
        color: #888888;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        cursor: pointer;
        border-radius: 5px;
        padding: 0 8px;
        &.on {
          color: #fff;
          background-color: #ec0147;
        }
        .info {
          padding: 0px 5px;
        }
        .white,
        .black {
          position: relative;
        }
        .path-tooltip {
          position: absolute;
          width: 370px;
          z-index: 10;
          background-color: #1B1B1D;
          left: -198px;
          top: 23px;
          padding: 25px 30px 25px 15px;
          border-radius: 11px;
          border: 1px solid rgba(255, 255, 255, 0.30);
          box-shadow: 0px 23px 15px rgba(0, 0, 0, 0.08);
          .title {
            color: #FFF;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            text-align: left;
            padding-bottom: 40px;
          }
          .description {
            margin-top: 20px;
            color: #FBCF0A;
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            &::after {
              margin-top: 13px;
              content: "";
              display: inline-block;
              vertical-align: baseline;
              width: 100%;
              height: 1px;
              background-color: #444;
            }
            &.orange {
              color: #FB810A;
              text-align: right;
            }
          }
          .alert__wrap {
            position: relative;
            .icon {
              position: absolute;
              top: 1px;
              left: 25px;
            }
            .alert {
              color: #999;
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
              width: 274px;
              margin-left: 50px;
              margin-top: 8px;
              text-align: left;
            }
          }
          .reporting__stream__statistics-graph {
            position: relative;
            height: 116px;
            margin-left: 18px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.5);
            background-size: 100% 100%;
            .lines {
              position: absolute;
              width: 100%;
              height: 100%;
              .vertical {
                span {
                  position: absolute;
                  top: 0;
                  left: 25%;
                  height: 100%;
                  border-left: 1px solid rgba(171, 133, 255, 0.5);
                }
                span:nth-child(2) {
                  left: 50%;
                }
                span:nth-child(3) {
                  left: 75%;
                }
              }
              .horizontal {
                span {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  border-top: 1px solid rgba(255, 255, 255, 0.12);
                }
                span:nth-child(2) {
                  top: 33.33333%;
                }
                span:nth-child(3) {
                  top: 66.66666%;
                }
              }
            }
            &::before {
              content: "Activity";
              position: absolute;
              bottom: -20px;
              right: 0;
              color: #767676;
              font-size: 12px;
            }

            &::after {
              content: "User";
              position: absolute;
              top: 5px;
              left: -25px;
              color: #767676;
              font-size: 12px;
              transform: rotate(-90deg);
            }

            .line {
              &.nothing {
                position: absolute;
                top: 0;
                left: 0;
                width: 25%;
                height: 100%;
                background: url(../../../assets/img/heatmap/img-line-curve-01.svg) no-repeat center top;
                background-size: 105% 102.5%;
              }

              &.median {
                position: absolute;
                top: 0;
                left: 25%;
                width: 50%;
                height: 100%;
                background: url(../../../assets/img/heatmap/img-line-curve-02.svg) rgba(171, 133, 255, 0.5) no-repeat center top;
                background-size: 105% 102.5%;
                transition: background-color 0.15s ease;
                cursor: pointer;

                &.active {
                  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
                  border: 3px solid #ffffff;
                  border-radius: 7px;
                  margin: -3px;
                  z-index: 10;

                  &:before {
                    content: "";
                    position: absolute;
                    bottom: -8px;
                    left: 50%;
                    margin-left: -6px;
                    width: 0;
                    height: 0;
                    border-left: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-top: 6px solid #fff;
                  }
                }
              }

              &.extreme {
                position: absolute;
                top: 0;
                left: 75%;
                width: 25%;
                height: 100%;
                background: url(../../../assets/img/heatmap/img-line-curve-03.svg) rgba(99, 61, 182, 0.5) no-repeat center top;
                background-size: 105% 102.5%;
                transition: background-color 0.15s ease;
                cursor: pointer;

                &.active {
                  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
                  border: 3px solid #ffffff;
                  border-radius: 7px;
                  margin: -3px;
                  z-index: 10;

                  &:before {
                    content: "";
                    position: absolute;
                    bottom: -8px;
                    left: 20%;
                    margin-left: -6px;
                    width: 0;
                    height: 0;
                    border-left: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-top: 6px solid #fff;
                  }
                }
              }

              .label {
                display: block;
                font-size: 14px;
                padding: 26px 10px 45px 10px;
                height: 27px;
                background: url(../../../assets/img/heatmap/img-path-check-02.svg) no-repeat center bottom;
                color: #dfdfdf;
                line-height: 1.15;
                text-align: center;
              }

              &.active .label {
                background-image: url(../../../assets/img/heatmap/img-path-check-01.svg);
              }

              .name {
                color: #A989F3;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                position: absolute;
                top: -20px;
                left: 25%;

                &.extreme {
                  left: 20%
                }
              }
            }
          }
        }
      }
    }
  }

  .zoom__wrap {
    display: flex;
    justify-content: center;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    background: rgba(0, 0, 0, 0.40);
    .box__wrap {
      display: flex;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.10);
      background: rgba(0, 0, 0, 0.40);
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        height: 26px;
        color: #888888;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        cursor: pointer;
        &.on {
          color: #fff;
          background-color: #ec0147;
          border-radius: 5px;
        }
        .info {
          padding: 0px 8px;
        }
        .white,
        .black {
          position: relative;
        }
        .path-tooltip {
          position: absolute;
          width: 320px;
          z-index: 10;
          background-color: #1B1B1D;
          left: -183px;
          top: 25px;
          padding: 25px 25px 0px 25px;
          border-radius: 11px;
          border: 1px solid rgba(255, 255, 255, 0.30);
          box-shadow: 0px 23px 15px rgba(0, 0, 0, 0.08);
          .title {
            color: #FF8400;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            text-align: left;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
          }
          .percentage {
            color: #AAA;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
          }
          .legend {
            margin:0 25px;
        position: relative;

        &.weight {
          margin: 0 19px 0 12px;
          padding-bottom: 43px;
        }

        .line {
          position: absolute;
          top: 27px;
          background-color: #ffffff;
          height: 2px;
          border-radius: 2px;
          width: 355%;
          left: 50%;
          opacity: 0.1;
        }

        .item {
          display: inline-block;
          width: 21%;
          text-align: center;
          color: #aaaaaa;
          font-size: 11px;
          vertical-align: top;
          position: relative;
          height: 50px;

          span {
            position: absolute;
            top: 55px;
            left: calc(50% - 10px);
          }

          &:first-child {
            width: 23%;
          }

          &:last-child {
            width: 14%;
          }

          .icon {
            width: 100%;
            height: 56px;
            background-position: center;
            background-size: auto;
            background-repeat: no-repeat;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 11;

            &.zoomin {
              &.weight-1 {
              }

              &.weight-2 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-in-2.svg);
              }

              &.weight-3 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-in-3.svg);
              }

              &.weight-4 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-in-4.svg);
              }

              &.weight-5 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-in-5.svg);
              }
            }

            &.zoomout {
              &.weight-1 {
              }

              &.weight-2 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-out-2.svg);
              }

              &.weight-3 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-out-3.svg);
              }

              &.weight-4 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-out-4.svg);
              }

              &.weight-5 {
                background-image: url(../../../assets/img/heatmap/grid-cell-zoom-out-5.svg);
              }
            }
          }
        }
      }
        }
      }
    }
  }
  .swipe__wrap {
    display: flex;
    justify-content: center;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    background: rgba(0, 0, 0, 0.40);
    .box__wrap {
      display: flex;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.10);
      background: rgba(0, 0, 0, 0.40);
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        height: 26px;
        color: #888888;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        cursor: pointer;
        &.on {
          color: #fff;
          border-radius: 5px;
          background-color: #ec0147;
        }
        .info {
          padding: 0px 8px;
        }
        .white,
        .black {
          position: relative;
        }
        .path-tooltip {
          display: flex;
          position: absolute;
          width: 340px;
          z-index: 10;
          background-color: #1B1B1D;
          left: -176px;
          top: 24px;
          padding: 25px 30px 14px 15px;
          border-radius: 11px;
          border: 1px solid rgba(255, 255, 255, 0.30);
          box-shadow: 0px 23px 15px rgba(0, 0, 0, 0.08);
          .arrow {
            left: 178px;
          }
          .title {
            display: flex;
            flex-direction: column;
            text-align: left;
            width: 46px;
            .orange {
              color: #FF8400;
              font-size: 13px;
              font-style: normal;
              font-weight: 500;
              line-height: 19px;
            }
            .percentage {
              color: #AAA;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              margin-top: 7px;
            }
          }
          .legend {
          display: inline-block;
          vertical-align: top;
          width: calc(100% - 110px);
          margin-top: -8px;
          margin-left: 35px;

          .item {
            display: inline-block;
            width: 21%;
            text-align: center;
            color: #aaaaaa;
            font-size: 11px;

            &:first-child {
              width: 23%;
            }

            &:last-child {
              width: 14%;
            }

            .icon {
              width: 100%;
              height: 50px;
              background-position: center;
              background-size: auto;
              background-repeat: no-repeat;

              &.up {
                &.weight-1 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-up-1.svg);
                }

                &.weight-2 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-up-2.svg);
                }

                &.weight-3 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-up-3.svg);
                }

                &.weight-4 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-up-4.svg);
                }

                &.weight-5 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-up-5.svg);
                }
              }

              &.down {
                &.weight-1 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-down-1.svg);
                }

                &.weight-2 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-down-2.svg);
                }

                &.weight-3 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-down-3.svg);
                }

                &.weight-4 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-down-4.svg);
                }

                &.weight-5 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-down-5.svg);
                }
              }

              &.left {
                &.weight-1 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-left-1.svg);
                }

                &.weight-2 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-left-2.svg);
                }

                &.weight-3 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-left-3.svg);
                }

                &.weight-4 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-left-4.svg);
                }

                &.weight-5 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-left-5.svg);
                }
              }

              &.right {
                &.weight-1 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-right-1.svg);
                }

                &.weight-2 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-right-2.svg);
                }

                &.weight-3 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-right-3.svg);
                }

                &.weight-4 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-right-4.svg);
                }

                &.weight-5 {
                  background-image: url(../../../assets/img/heatmap/grid-cell-swipe-right-5.svg);
                }
              }
            }
          }
          }
        }
      }
    }
  }

  .tap__wrap {
    display: flex;
    justify-content: center;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.10);
    background: rgba(0, 0, 0, 0.4);

    .box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      height: 28px;
      color: #888888;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;

      .icon {
        position: relative;
        padding-right: 8px;
      }

      & span {
        color: #ffffff;
      }
    }
  }
}</style>
